<div class="main-content">
  <div class="photo-header">
    <h1>{{ "induction_completed_photo_list_title" | translate }}</h1>
  </div>
  <div class="divider"></div>
  <div>
    <mat-grid-list
      [cols]="cols$ | async"
      rowHeight="22em"
      gutterSize="1em"
      class="photo-grid-list"
    >
      @for (photo of signInSignOutdocuments; track photo) {
      <mat-grid-tile>
        <mat-card class="photo-card">
          <img
            mat-card-image
            class="photo-image"
            [src]="photo.fileDataInBase64"
            loading="lazy"
          />
          <mat-card-content class="photo-content">
            <div
              fxLayout="column"
              fxFlex="100"
              fxLayoutGap="5px"
              class="card-content"
            >
              <div class="color-city-blue font-size-text-bold">
                {{ photo.visitorTypeUploadReasonDescription }}
              </div>
              <div class="color-dark-blue font-size-small-text">
                {{ photo.comments }}
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <!-- Full-width action button inside the card -->
            <div fxLayout="column" fxFlex="100" fxLayoutGap="5px">
              <div>
                <button
                  mat-button
                  class="photo-button-delete"
                  (click)="deletePhoto(photo)"
                >
                  {{ "induction_completed_photo_list_delete" | translate }}
                </button>
              </div>
            </div>
          </mat-card-actions>
        </mat-card>
      </mat-grid-tile>
      }
    </mat-grid-list>
  </div>
  <div class="divider"></div>
  <button
    mat-raised-button
    id="induction_completed_photo_list_cancel"
    data-testid="induction_completed_photo_list_cancel"
    (click)="addPhotos()"
  >
    <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
      <mat-icon class="add-photo-icon">camera_alt</mat-icon>
      {{ "induction_completed_photo_list_add_photos" | translate }}
    </div>
  </button>
  <div class="divider"></div>
  <button
    mat-stroked-button
    class="color-city-blue btn-border-color"
    id="induction_completed_photo_list_cancel"
    data-testid="induction_completed_photo_list_cancel"
    (click)="closePhotoList()"
  >
    {{ "induction_completed_photo_list_cancel" | translate }}
  </button>
</div>
